module.exports = __webpack_public_path__ + "static/media/do-not-enter.aae02f3a.svg";